import { IconsProps } from '@/types/shared'
import React from 'react'

const CustomerIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M19.39 11.75C19.46 12.16 19.5 12.57 19.5 13C19.5 17.41 15.91 21 11.5 21C7.09 21 3.5 17.41 3.5 13C3.5 12.95 3.51 12.9 3.5 12.86C6.1 11.88 8.19 9.87 9.24 7.31C12.62 11.45 17.21 11.04 18.23 10.92L17.34 8.99C17.21 9 12.72 9.37 10.16 5.13C11.17 4.97 11.87 4.98 12.75 5.12C15.27 3.97 14.68 4.23 15.51 3.86C14.28 3.3 12.93 3 11.5 3C5.98 3 1.5 7.48 1.5 13C1.5 18.52 5.98 23 11.5 23C17.02 23 21.5 18.52 21.5 13C21.5 11.57 21.2 10.22 20.66 8.99L19.39 11.75ZM7.58 6.03C6.95 7.92 5.63 9.5 3.92 10.47C4.55 8.58 5.87 7 7.58 6.03Z"
                    fill="currentColor"
                />
                <path
                    d="M14.5 15.25C15.1904 15.25 15.75 14.6904 15.75 14C15.75 13.3096 15.1904 12.75 14.5 12.75C13.8096 12.75 13.25 13.3096 13.25 14C13.25 14.6904 13.8096 15.25 14.5 15.25Z"
                    fill="currentColor"
                />
                <path
                    d="M8.5 15.25C9.19036 15.25 9.75 14.6904 9.75 14C9.75 13.3096 9.19036 12.75 8.5 12.75C7.80964 12.75 7.25 13.3096 7.25 14C7.25 14.6904 7.80964 15.25 8.5 15.25Z"
                    fill="currentColor"
                />
                <path
                    d="M22.5 5.5L20.1 4.4L19 2L17.9 4.4L15.5 5.5L17.9 6.6L19 9L20.1 6.6L22.5 5.5Z"
                    fill="currentColor"
                />
            </svg>
        </div>
    )
}

export default CustomerIcons
